<template>
  <div>
    <b-table
      striped
      hover
      :selectable="canSelect"
      select-mode="single"
      @row-selected="onRowSelected"
      :items="items"
      :fields="tableFields"
      :filter="filter"
      @filtered="onFiltered"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:cell(vehicleLabel)="data">
        <VehicleBrief
          :label="data.item.vehicleLabel"
          :showIndividualCall="false"
          :addGroupCall="false"
          sizeClass="h6"
        >
        </VehicleBrief>
      </template>

      <template
        v-slot:cell(actions)="data"
        v-if="showCallButtons || showAddButton || showLinkToVehicleOnMapButton"
      >
        <VehicleBrief
          :label="data.item.vehicleLabel"
          :showGps="false"
          :showLabel="false"
          :showLink="false"
          :showIndividualCall="showCallButtons"
          :addGroupCall="showCallButtons"
          :showVehicleOnMap="showLinkToVehicleOnMapButton"
          sizeClass="h5"
        >
        </VehicleBrief>
        <span
          v-if="showAddButton"
          :title="$t('vehicle.add')"
          @click="onActionAdd(data.item)"
          style="cursor: pointer"
          ><em class="fa fa-plus"></em
        ></span>
      </template>
    </b-table>

    <TablePagination
      :total-rows="totalRows"
      :per-page="perPage"
      @pageChange="onPageChange"
      :currentPage="currentPage"
			@perPageChange="onPerPageChange"
			:extendedPagination="true"
			:perPageArray="[10, 25, 50]"
    >
    </TablePagination>
  </div>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination'
import realtime from '@/store/realtime/realtime'
import VehicleBrief from '@/components/Realtime/VehicleBrief'

export default {
  name: 'vehicleListTable',
  components: { TablePagination, VehicleBrief },
  props: [
    'filter',
    'selectable',
    'exclusions',
    'showCallButtons',
    'showAddButton',
    'showLinkToVehicleOnMapButton'
  ],
  data: function () {
    return {
      perPage: 10,
      currentPage: 1,
      filteredRows: 0,
      tableFields: [],
      filteredItems: [],
      canSelect: this.selectable !== false,
    }
  },
  computed: {
    fields() {
      let fields = [
        {
          key: 'vehicleLabel',
          label: this.$t('vehicle.label'),
          sortable: true,
        },
        {
          key: 'computerLabel',
          label: this.$t('vehicle.computer'),
          sortable: true,
        },
      ]

      for (let ovf of this.$store.state.realtime.organizationVehicleFeatures) {
        if (
          ovf.name == 'VEHICLE_TYPE' ||
          ovf.name == 'TECHNICAL_NUMBER' ||
          ovf.name == 'NAME' ||
          ovf.name == 'VEHICLE_COMPUTER_TYPE'
        ) {
          fields.push({
            key: 'features.' + ovf.name,
            label: this.$t(ovf.descriptionId),
            sortable: true,
          })
        }
      }

      if (this.showCallButtons || this.showAddButton || this.showLinkToVehicleOnMapButton) {
        // Here we could add: || this.<some-other-action-button>
        fields.push({
          key: 'actions',
          label: this.$t('vehicle.actions'),
          sortable: false,
        })
      }
      return fields
    },
    items() {
      let list = []
      if (this.exclusions) {
        for (const v of this.$store.state.realtime.vehicles.list) {
          if (this.exclusions.indexOf(v.vehicleId) < 0) {
            list.push(v)
          }
        }
        return list
      }
      return this.$store.state.realtime.vehicles.list
    },
    totalRows() {
      if (this.filteredRows) return this.filteredRows
      return this.items ? this.items.length : 0
    },
  },
  mount() {
    if (!this.filter || this.filter == '')
      this.$emit('filteredRows', this.items)
  },
  updated() {
    if (!this.filter || this.filter == '')
      this.$emit('filteredRows', this.items)
  },
  beforeCreate() {
    if (!this.$store.state.realtime) {
      this.$store.registerModule('realtime', realtime)
    }
    this.$store.dispatch('realtime/getVehicles')
    this.$store.dispatch('realtime/getOrganizationVehicleFeatures', null)
    this.tableFields = this.fields
  },
  methods: {
    onRowSelected(items) {
      this.$emit('selectItem', items[0])
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length
      this.currentPage = 1
      this.$emit('filteredRows', filteredItems)
      this.filteredItems = filteredItems;
    },
    onPageChange(page) {
      this.currentPage = page
    },
    onPerPageChange(perPage) {
			this.perPage = perPage
			this.onFiltered(this.filteredItems)
		},
    onActionAdd(vehicle) {
      this.$emit('actionAdd', vehicle)
    },
  },
  watch: {
    fields: {
      handler: function () {
        if (
          this.fields != null &&
          JSON.stringify(this.fields) !== JSON.stringify(this.tableFields)
        ) {
          this.tableFields = this.fields
        }
      },
      deep: false
    },
  },
}
</script>
